const COMMODITIES = [
  { name: 'Electricity', key: 'ELECTRICITY' },
  { name: 'Natural Gas', key: 'GAS' },
];

const CURRENCIES = [
  { name: 'U.S. Dollar (USD)', value: 'USD', symbol: '$' },
  { name: 'CA Dollar (CAD)', value: 'CAD', symbol: '$' },
  { name: 'European Euro (EUR)', value: 'EUR', symbol: '€' },
  { name: 'Australian Dollar (AUD)', value: 'AUD', symbol: '$' },
  { name: 'Japanese Yen (JPY)', value: 'JPY', symbol: '¥' },
  { name: 'British Pound (GBP)', value: 'GBP', symbol: '£' },
];

const DAYS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

const DEVICE_CHARGE_STATUS = {
  CHARGING: 'Charging',
  NOT_CHARGING: 'Not Charging',
  FULLY_CHARGED: 'Fully Charged',
  UNKNOWN: 'Unknown',
  default: '--',
};

const DEVICE_KINDS = {
  battery: 'Battery',
  circuitBreaker: 'Circuit Breaker',
  ev: 'Connected EV',
  evse: 'EV Charger',
  'evse-circuitBreaker': 'Circuit Breaker / EV Charger',
  hwh: 'Water Heater',
  rac: 'Room AC',
  tstat: 'HVAC',
  v2g: 'Vehicle to Grid',
  pvsystem: 'PV System',
  solarinv: 'Solar Inverter',
  default: 'Unknown',
};

const DEVICE_MFGS = {
  aosmith: 'AO Smith',
  apricity: 'Apricity',
  aquanta: 'Aquanta',
  armada: 'Armada',
  chargepoint: 'ChargePoint',
  'duracell-power-center': 'Duracell Power Center',
  eaton: 'Eaton',
  ecobee: 'Ecobee',
  eguana: 'Eguana',
  emporia: 'Emporia',
  enelx: 'Enel X',
  enphase: 'Enphase',
  eradio: 'eRadio',
  evocharge: 'EvoCharge',
  fermata: 'Fermata',
  fortress: 'Fortress Power',
  flair: 'Flair',
  flo: 'Flo',
  franklinwh: 'FranklinWH',
  ge: 'GE',
  honeywell: 'Honeywell Home',
  honeywellAcc: 'Amazon',
  honeywellTcc: 'Honeywell TCC',
  intesis: 'Intesis',
  juicebox: 'JuiceBox',
  juicenet: 'JuiceNet',
  mysa: 'Mysa',
  neovolta: 'NeoVolta',
  nest: 'Google Nest',
  nri: 'Northern Reliability',
  pika: 'Generac',
  rheem: 'Rheem',
  savant: 'Savant',
  sinope: 'Sinopé',
  sensi: 'Sensi',
  sensibo: 'Sensibo',
  solaredge: 'SolarEdge',
  sonnen: 'sonnenBatterie',
  stash: 'Stash',
  sunverge: 'Sunverge',
  skycentrics: 'SkyCentrics',
  tesla: 'Tesla',
  tricklestar: 'TrickleStar',
  'vp-sim': 'VP Sim',
  smartcar: 'Smartcar',
  wallbox: 'Wallbox',
  default: 'Unknown',
};

const DEVICE_MFGS_OPTIONS = Object.entries(DEVICE_MFGS).map(([key, value]) => {
  const field = { key, value };
  if (key === 'aosmith') {
    field.providerEnabled = 'enableAOSmith';
    field.relatedDeviceKinds = ['hwh'];
  }
  if (key === 'apricity') {
    field.providerEnabled = 'enableApricity';
    field.relatedDeviceKinds = ['hwh'];
  }
  if (key === 'aquanta') {
    field.providerEnabled = 'enableAquanta';
    field.relatedDeviceKinds = ['hwh'];
  }
  if (key === 'armada') {
    field.providerEnabled = 'enableArmadaPower';
    field.relatedDeviceKinds = ['hwh'];
  }
  if (key === 'chargepoint') {
    field.providerEnabled = 'enableChargepoint';
    field.relatedDeviceKinds = ['evse'];
  }
  if (key === 'duracell-power-center') {
    field.providerEnabled = 'enableDuracellPowerCenter';
    field.relatedDeviceKinds = ['battery'];
  }
  if (key === 'eaton') {
    field.providerEnabled = 'enableEatonEM';
    field.relatedDeviceKinds = ['circuitBreaker', 'evse-circuitBreaker'];
  }
  if (key === 'ecobee') {
    field.providerEnabled = 'enableEcobee';
    field.relatedDeviceKinds = ['tstat'];
  }
  if (key === 'eguana') {
    field.providerEnabled = 'enableEguana';
    field.relatedDeviceKinds = ['battery'];
  }
  if (key === 'emporia') {
    field.providerEnabled = 'enableEmporia';
    field.relatedDeviceKinds = ['battery', 'evse'];
  }
  if (key === 'enphase') {
    field.providerEnabled = 'enableEnphase';
    field.relatedDeviceKinds = ['battery', 'pvsystem', 'solarinv'];
  }
  if (key === 'enelx') {
    field.providerEnabled = 'enableEnelx';
    field.relatedDeviceKinds = ['evse'];
  }
  if (key === 'eradio') {
    field.providerEnabled = 'enableEradio';
    field.relatedDeviceKinds = ['hwh'];
  }
  if (key === 'evocharge') {
    field.providerEnabled = 'enableEvoCharge';
    field.relatedDeviceKinds = ['evse'];
  }
  if (key === 'fermata') {
    field.providerEnabled = 'enableFermata';
    field.relatedDeviceKinds = ['v2g'];
  }
  if(key === 'fortress') {
    field.providerEnabled = 'enableFortress';
    field.relatedDeviceKinds = ['battery'];
  }
  if (key === 'flair') {
    field.providerEnabled = 'enableFlair';
    field.relatedDeviceKinds = ['tstat'];
  }
  if (key === 'flo') {
    field.providerEnabled = 'enableFlo';
    field.relatedDeviceKinds = ['evse'];
  }
  if(key === 'franklinwh') {
    field.providerEnabled = 'enableFranklinWH';
    field.relatedDeviceKinds = ['battery'];
  }
  if (key === 'ge') {
    field.providerEnabled = 'enableGe';
    field.relatedDeviceKinds = ['hwh', 'rac'];
  }
  if (key === 'honeywellAcc') {
    field.providerEnabled = 'enableHoneywellAcc';
    field.relatedDeviceKinds = ['tstat'];
  }
  if (key === 'intesis') {
    field.providerEnabled = 'enableIntesis';
    field.relatedDeviceKinds = ['tstat'];
  }
  if (key === 'juicebox') {
    field.providerEnabled = 'enableJuicebox';
    field.relatedDeviceKinds = ['evse'];
  }
  if (key === 'juicenet') {
    field.providerEnabled = 'enableJuicenet';
    field.relatedDeviceKinds = ['evse'];
  }
  if (key === 'mysa') {
    field.providerEnabled = 'enableMysa';
    field.relatedDeviceKinds = ['tstat'];
  }
  if (key === 'nest') {
    field.providerEnabled = 'enableNest';
    field.relatedDeviceKinds = ['tstat'];
  }
  if (key === 'nri') {
    field.providerEnabled = 'enableNRI';
    field.relatedDeviceKinds = ['battery'];
  }
  if(key === 'neovolta') {
    field.providerEnabled = 'enableNeoVolta';
    field.relatedDeviceKinds = ['battery'];
  }
  if (key === 'pika') {
    field.providerEnabled = 'enablePika';
    field.relatedDeviceKinds = ['battery'];
  }
  if (key === 'rheem') {
    field.providerEnabled = 'enableRheem';
    field.relatedDeviceKinds = ['hwh'];
  }
  if (key === 'savant') {
    field.providerEnabled = 'enableSavant';
    field.relatedDeviceKinds = ['battery'];
  }
  if (key === 'sinope') {
    field.providerEnabled = 'enableSinope';
    field.relatedDeviceKinds = ['tstat'];
  }
  if (key === 'sensi') {
    field.providerEnabled = 'enableSensi';
    field.relatedDeviceKinds = ['tstat'];
  }
  if (key === 'sensibo') {
    field.providerEnabled = 'enableSensibo';
    field.relatedDeviceKinds = ['tstat'];
  }
  if (key === 'solaredge') {
    field.providerEnabled = 'enableSolaredge';
    field.relatedDeviceKinds = ['battery'];
  }
  if (key === 'sonnen') {
    field.providerEnabled = 'enableSonnen';
    field.relatedDeviceKinds = ['battery'];
  }
  if (key === 'stash') {
    field.providerEnabled = 'enableStash';
    field.relatedDeviceKinds = ['storage-hvac'];
  }
  if (key === 'sunverge') {
    field.providerEnabled = 'enableSunverge';
    field.relatedDeviceKinds = ['battery'];
  }
  if (key === 'skycentrics') {
    field.providerEnabled = 'enableSkyCentrics';
    field.relatedDeviceKinds = ['battery'];
  }
  if (key === 'tesla') {
    field.providerEnabled = 'enableTesla';
    field.relatedDeviceKinds = ['battery'];
  }
  if (key === 'tricklestar') {
    field.providerEnabled = 'enableTrickleStar';
    field.relatedDeviceKinds = ['hwh', 'tstat'];
  }
  if (key === 'vp-sim') {
    field.providerEnabled = 'enableSimulatedDevices';
    field.relatedDeviceKinds = ['battery', 'ev', 'evse'];
  }
  if (key === 'wallbox') {
    field.providerEnabled = 'enableWallbox';
    field.relatedDeviceKinds = ['evse'];
  }
  /** Paired MFGs */
  if (key === 'honeywell') {
    field.providerEnabled = 'enableHoneywell';
    field.relatedDeviceKinds = ['tstat'];
  }
  if (key === 'honeywellTcc') {
    field.providerEnabled = 'enableHoneywell';
    field.relatedDeviceKinds = ['tstat'];
  }

  return field;
});

const DEVICE_SUB_BRAND = {
  american: 'American',
  aosmith: 'AO Smith',
  duracell: 'Duracell',
  lochinvar: 'Lochinvar',
  reliance: 'Reliance',
  rheem: 'Rheem',
  ruud: 'Ruud',
  state: 'State',
  uscraftmaster: 'U.S. Craftmaster',
  default: 'Unknown',
};

const EVENT_CATEGORY = {
  pre: 'Pre Event',
  event: 'Event',
  post: 'Post Event',
  notification: 'Notification',
  recurring: 'Recurring',
  default: 'None',
};

const EVENT_INITIATOR = {
  'platoon-event': 'Platoon Event',
  schedule: 'Schedule',
  'message-campaign': 'Message Campaign',
  'ad-hoc': 'Ad Hoc',
  default: 'Ad Hoc',
};

const EVENT_TYPE = {
  hwh: 'Water Heater',
  tstat: 'HVAC',
  battery: 'Battery',
  v2g: 'Vehicle to Grid',
  rac: 'Room AC',
  evse: 'EV Charger',
  ev: 'Connected EV',
  circuitBreaker: 'Circuit Breaker',
  'dr-event': 'Event Notification',
  'dr-ad-hoc': 'Event Notification',
  behavioral: 'Behavioral Event',
  email: 'Ad Hoc Message',
  'message-campaign': 'Message Campaign',
  'direct-message': 'Direct Message',
  'offline-report': 'Offline Report',
  default: 'None',
};

const LINKED_ACCOUNT_TYPES = {
  aosmith: 'AO Smith',
  aquanta: 'Aquanta API',
  arm: 'ARM',
  armada: 'Armada Power',
  chargepoint: 'ChargePoint API',
  eaton: 'Eaton v2',
  ecobee: 'Ecobee API',
  'ecobee-legacy': 'Ecobee Legacy',
  eguana: 'Eguana',
  enphase: 'Enphase',
  eradio: 'e-Radio API',
  emporia: 'Emporia',
  flair: 'Flair',
  flo: 'Flo API',
  ge: 'GE Connect Plus API',
  honeywell: 'Honeywell API',
  honeywellAcc: 'Amazon Smart Thermostat API',
  honeywellTcc: 'Honeywell TCC API',
  intesis: 'Intesis',
  juicenet: 'JuiceNet API',
  mysa: 'Mysa API',
  nest: 'Nest Energy API',
  nri: 'Northern Reliability API',
  pika: 'Pika API',
  postgrid: 'PostGrid',
  rheem_partner: 'Rheem Partner API',
  'rhr-lite': 'RHR Lite',
  sensi: 'Sensi API',
  sensibo: 'Sensibo API',
  sonnen: 'Sonnen V2 API',
  sunverge: 'Sunverge API',
  solaredge: 'SolarEdge API',
  tango: 'Tango',
  tesla: 'Tesla Powerwall API',
  'vp-sim': 'VP Sim',
  wallbox: 'Wallbox API',
  default: 'Unknown',
};

const LINKED_ACCOUNT_TYPES_PROVIDER_SETTINGS = Object.entries(LINKED_ACCOUNT_TYPES).map(([key, value]) => {
  const field = { key, value };
  if (key === 'aosmith') field.providerEnabled = 'enableAOSmith';
  if (key === 'aquanta') field.providerEnabled = 'enableAquanta';
  if (key === 'armada') field.providerEnabled = 'enableArmadaPower';
  if (key === 'chargepoint') field.providerEnabled = 'enableChargepoint';
  if (key === 'eaton') field.providerEnabled = 'enableEatonEM';
  if (key === 'ecobee') field.providerEnabled = 'enableEcobee';
  if (key === 'ecobee-legacy') field.providerEnabled = ''; /** Missing Setting Keys */
  if (key === 'eguana') field.providerEnabled = 'enableEguana';
  if (key === 'enphase') field.providerEnabled = 'enableEnphase';
  if (key === 'emporia') field.providerEnabled = 'enableEmporia';
  if (key === 'eradio') field.providerEnabled = 'enableEradio';
  if (key === 'flair') field.providerEnabled = 'enableFlair';
  if (key === 'flo') field.providerEnabled = 'enableFlo';
  if (key === 'ge') field.providerEnabled = 'enableGe';
  if (key === 'honeywellAcc') field.providerEnabled = 'enableHoneywellAcc';
  if (key === 'intesis') field.providerEnabled = 'enableIntesis';
  if (key === 'juicenet') field.providerEnabled = 'enableJuicenet';
  if (key === 'mysa') field.providerEnabled = 'enableMysa';
  if (key === 'nest') field.providerEnabled = 'enableNest';
  if (key === 'nri') field.providerEnabled = 'enableNRI';
  if (key === 'pika') field.providerEnabled = 'enablePika';
  if (key === 'rheem_partner') field.providerEnabled = 'enableRheem';
  if (key === 'sensi') field.providerEnabled = 'enableSensi';
  if (key === 'sensibo') field.providerEnabled = 'enableSensibo';
  if (key === 'solaredge') field.providerEnabled = 'enableSolaredge';
  if (key === 'sonnen') field.providerEnabled = 'enableSonnen';
  if (key === 'sunverge') field.providerEnabled = 'enableSunverge';
  if (key === 'tesla') field.providerEnabled = 'enableTesla';
  if (key === 'vp-sim') field.providerEnabled = 'enableSimulatedDevices';
  if (key === 'wallbox') field.providerEnabled = 'enableWallbox';

  /** Paired MFGs */
  if (key === 'honeywell') field.providerEnabled = 'enableHoneywell';
  if (key === 'honeywellTcc') field.providerEnabled = 'enableHoneywell';
  if (key === 'arm') field.providerEnabled = 'enableIncentiveProcessing';
  if (key === 'tango') field.providerEnabled = 'enableIncentiveProcessing';
  if (key === 'postgrid') field.providerEnabled = 'enableIncentiveProcessing';

  return field;
});

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const PAYMENT_TYPES = {
  GIFT_CARD: 'Gift Card',
  default: 'Unknown',
};

const STATE_NAMES = [
  { name: 'ALABAMA', abbreviation: 'AL' },
  { name: 'ALASKA', abbreviation: 'AK' },
  { name: 'AMERICAN SAMOA', abbreviation: 'AS' },
  { name: 'ARIZONA', abbreviation: 'AZ' },
  { name: 'ARKANSAS', abbreviation: 'AR' },
  { name: 'CALIFORNIA', abbreviation: 'CA' },
  { name: 'COLORADO', abbreviation: 'CO' },
  { name: 'CONNECTICUT', abbreviation: 'CT' },
  { name: 'DELAWARE', abbreviation: 'DE' },
  { name: 'DISTRICT OF COLUMBIA', abbreviation: 'DC' },
  { name: 'FEDERATED STATES OF MICRONESIA', abbreviation: 'FM' },
  { name: 'FLORIDA', abbreviation: 'FL' },
  { name: 'GEORGIA', abbreviation: 'GA' },
  { name: 'GUAM', abbreviation: 'GU' },
  { name: 'HAWAII', abbreviation: 'HI' },
  { name: 'IDAHO', abbreviation: 'ID' },
  { name: 'ILLINOIS', abbreviation: 'IL' },
  { name: 'INDIANA', abbreviation: 'IN' },
  { name: 'IOWA', abbreviation: 'IA' },
  { name: 'KANSAS', abbreviation: 'KS' },
  { name: 'KENTUCKY', abbreviation: 'KY' },
  { name: 'LOUISIANA', abbreviation: 'LA' },
  { name: 'MAINE', abbreviation: 'ME' },
  { name: 'MARSHALL ISLANDS', abbreviation: 'MH' },
  { name: 'MARYLAND', abbreviation: 'MD' },
  { name: 'MASSACHUSETTS', abbreviation: 'MA' },
  { name: 'MICHIGAN', abbreviation: 'MI' },
  { name: 'MINNESOTA', abbreviation: 'MN' },
  { name: 'MISSISSIPPI', abbreviation: 'MS' },
  { name: 'MISSOURI', abbreviation: 'MO' },
  { name: 'MONTANA', abbreviation: 'MT' },
  { name: 'NEBRASKA', abbreviation: 'NE' },
  { name: 'NEVADA', abbreviation: 'NV' },
  { name: 'NEW HAMPSHIRE', abbreviation: 'NH' },
  { name: 'NEW JERSEY', abbreviation: 'NJ' },
  { name: 'NEW MEXICO', abbreviation: 'NM' },
  { name: 'NEW YORK', abbreviation: 'NY' },
  { name: 'NORTH CAROLINA', abbreviation: 'NC' },
  { name: 'NORTH DAKOTA', abbreviation: 'ND' },
  { name: 'NORTHERN MARIANA ISLANDS', abbreviation: 'MP' },
  { name: 'OHIO', abbreviation: 'OH' },
  { name: 'OKLAHOMA', abbreviation: 'OK' },
  { name: 'OREGON', abbreviation: 'OR' },
  { name: 'PALAU', abbreviation: 'PW' },
  { name: 'PENNSYLVANIA', abbreviation: 'PA' },
  { name: 'PUERTO RICO', abbreviation: 'PR' },
  { name: 'RHODE ISLAND', abbreviation: 'RI' },
  { name: 'SOUTH CAROLINA', abbreviation: 'SC' },
  { name: 'SOUTH DAKOTA', abbreviation: 'SD' },
  { name: 'TENNESSEE', abbreviation: 'TN' },
  { name: 'TEXAS', abbreviation: 'TX' },
  { name: 'UTAH', abbreviation: 'UT' },
  { name: 'VERMONT', abbreviation: 'VT' },
  { name: 'VIRGIN ISLANDS', abbreviation: 'VI' },
  { name: 'VIRGINIA', abbreviation: 'VA' },
  { name: 'WASHINGTON', abbreviation: 'WA' },
  { name: 'WEST VIRGINIA', abbreviation: 'WV' },
  { name: 'WISCONSIN', abbreviation: 'WI' },
  { name: 'WYOMING', abbreviation: 'WY' },
];

const STATE_NAMES_AU = [
  { name: 'AUSTRALIAN CAPITAL TERRITORY', abbreviation: 'ACT' },
  { name: 'NEW SOUTH WALES', abbreviation: 'NSW' },
  { name: 'NORTHERN TERRITORY', abbreviation: 'NT' },
  { name: 'SOUTH AUSTRALIA', abbreviation: 'SA' },
  { name: 'TASMANIA', abbreviation: 'TAS' },
  { name: 'QUEENSLAND', abbreviation: 'QLD' },
  { name: 'VICTORIA', abbreviation: 'VIC' },
  { name: 'WESTERN AUSTRALIA', abbreviation: 'WA' },
];

const STATE_NAMES_CA = [
  { name: 'ALBERTA', abbreviation: 'AB' },
  { name: 'BRITISH COLUMBIA', abbreviation: 'BC' },
  { name: 'MANITOBA', abbreviation: 'MB' },
  { name: 'NEW BRUNSWICK', abbreviation: 'NB' },
  { name: 'NEWFOUNDLAND AND LABRADOR', abbreviation: 'NL' },
  { name: 'NORTHWEST TERRITORIES', abbreviation: 'NT' },
  { name: 'NOVA SCOTIA', abbreviation: 'NS' },
  { name: 'NUNAVUT', abbreviation: 'NU' },
  { name: 'ONTARIO', abbreviation: 'ON' },
  { name: 'PRINCE EDWARD ISLAND', abbreviation: 'PE' },
  { name: 'QUEBEC', abbreviation: 'QC' },
  { name: 'SASKATCHEWAN', abbreviation: 'SK' },
  { name: 'YUKON', abbreviation: 'YT' },
];

const TIME_ZONES = [
  { name: 'US/Eastern', value: 'America/New_York' },
  { name: 'US/Central', value: 'America/Chicago' },
  { name: 'US/Mountain', value: 'America/Denver' },
  { name: 'US/Arizona', value: 'America/Phoenix' },
  { name: 'US/Pacific', value: 'America/Los_Angeles' },
  { name: 'US/Hawaii', value: 'Pacific/Honolulu' },
  { name: 'US/Atlantic', value: 'America/Puerto_Rico' },
  { name: 'CA/Atlantic', value: 'America/Halifax' },
  { name: 'CA/Eastern', value: 'America/Toronto' },
  { name: 'AU/Western', value: 'Australia/Perth' },
  { name: 'AU/Central Western', value: 'Australia/Eucla' },
  { name: 'AU/Central', value: 'Australia/Adelaide' },
  { name: 'AU/Central NT', value: 'Australia/Darwin' },
  { name: 'AU/Eastern', value: 'Australia/Sydney' },
  { name: 'AU/Eastern QLD', value: 'Australia/Brisbane' },
  { name: 'AU/Lord Howe', value: 'Australia/Lord_Howe' },

];

const VEHICLE_MAKES = {
  ACURA: 'Acura',
  AUDI: 'Audi',
  BMW: 'BMW',
  BUICK: 'Buick',
  CADILLAC: 'Cadillac',
  CHEVROLET: 'Chevrolet',
  CHRYSLYER: 'Chrysler',
  DODGE: 'Dodge',
  FORD: 'Ford',
  GMC: 'GMC',
  HYUNDAI: 'Hyundai',
  JAGUAR: 'Jaguar',
  JEEP: 'Jeep',
  KIA: 'Kia',
  LAND_ROVER: 'Land Rover',
  LEXUS: 'Lexus',
  LINCOLN: 'Lincoln',
  MERCEDES_BENZ: 'Mercedes-Benz',
  MINI: 'MINI',
  NISSAN: 'Nissan',
  OPEL: 'Opel',
  PEUGEOT: 'Peugeot',
  RAM: 'RAM',
  RENAULT: 'Renault',
  TESLA: 'Tesla',
  TOYOTA: 'Toyota',
  VOLKSWAGEN: 'Volkswagen',
  VOLVO: 'Volvo',
  default: 'Unknown',
};

const INCENTIVE_PAYMENT_SERVICES = {
  POSTGRID: 'Postgrid',
  TANGO: 'Tango',
  ARM: 'Arm',
};

const INCENTIVE_PAYMENT_TYPES = {
  GIFT_CARD: 'Gift Card',
  CHECK: 'Check',
};

/** Roles */
const ROLE_CONFIGURATIONS = {
  envision: {
    name: 'Envision',
    read: ['envision::read'],
    write: ['envision::write::view'],
    providerKey: 'enableForecasting',
    roleLabel(type, isLimited) {
      if (!type) return 'No Access';
      if (type === 'read') return 'Read Only';
      if (type === 'write') return isLimited ? 'Limited Access' : 'All Access';
      if (type === 'limitation') return null;
    },
  },
  shift: {
    name: 'Shift',
    read: ['shift::read'],
    write: ['shift::write::event', 'shift::write::asset', 'shift::write::enrollment'],
    providerKey: 'enableShift',
    limitedBy: 'platoonId',
    roleLabel(type, isLimited) {
      if (!type) return  'No Access';
      if (type === 'read') return 'Read Only';
      if (type === 'write') return isLimited ? 'Limited Flex Access' : 'Full Flex Access';
      if (type === 'limitation') return isLimited ? 'Limited Platoons' : 'All Platoons';
    },
  },
  relay: {
    name: 'Relay',
    read: ['relay::read'],
    write: ['relay::write::enrollment', 'relay::write::incentive', 'relay::write::marketing', 'relationship-manager'],
    providerKey: 'enableRelay',
    limitedBy: 'programId',
    roleLabel(type, isLimited) {
      if (!type) return 'No Access';
      if (type === 'read') return 'Read Only';
      if (type === 'write') return isLimited ? 'Limited Flex Access' : 'Full Flex Access';
      if (type === 'limitation') return isLimited ? 'Limited Programs' : 'All Programs';
    },
  },
  management: {
    name: 'Team Management',
    read: ['c-user'],
    write: ['c-manager'],
    roleLabel(type) {
      if (!type) return 'NONE';
      if (type === 'read') return 'VIEWER';
      if (type === 'write') return 'MANAGER';
      return null;
    },
  },
  platoon: {
    name: 'Platoon',
    read: ['platoon-user'],
    write: ['platoon'],
    limitedBy: 'platoonId',
    roleLabel(type, isLimited) {
      if (!type) return 'No Access';
      if (type === 'read') return 'Read Only';
      if (type === 'write') return 'All Access';
      if (type === 'limitation') return isLimited ? 'Limited Platoons' : 'All Platoons';
    },
  },
  legacy: {
    name: 'Legacy',
    read: ['user'],
    write: ['manager'],
    roleLabel(type) {
      if (!type) return 'No Access';
      if (type === 'read') return 'Read Only';
      if (type === 'write') return 'All Access';
      if (type === 'limitation') return 'All Access';
    },
  },
  admin: {
    type: 'admin',
    name: 'Admin',
    read: ['admin-ro'],
    write: ['admin', 'mlops-admin', 'invoice-admin'],
    roleLabel(type) {
      if (!type) return 'No Access';
      if (type === 'read') return 'Read Only';
      if (type === 'write') return 'All Access';
      if (type === 'limitation') return 'All Access';
    },
  },
};

const ROLE_TYPES = [
  /** ADMIN **/
  { name: 'Admin', value: 'admin', group: 'admin' },
  { name: 'Admin Read Only', value: 'admin-ro', group: 'admin' },
  { name: 'Invoice Admin', value: 'invoice-admin', group: 'admin' },
  { name: 'MLOps Admin', value: 'mlops-admin', group: 'admin' },

  /** Legacy **/
  { name: 'User', value: 'user', group: 'legacy' },
  { name: 'Manager', value: 'manager', group: 'legacy' },
  /** Platoon **/
  { name: 'House', value: 'house', group: 'platoon' },
  { name: 'Platoon', value: 'platoon', group: 'platoon' },
  { name: 'Platoon User', value: 'platoon-user', group: 'platoon' },
  /** COMPLIANCE **/
  { name: 'Compliance Manager', value: 'c-manager', group: 'compliance' },
  { name: 'Compliance User', value: 'c-user', group: 'compliance' },
  /** OTHER **/
  { name: 'Gravity Developer', value: 'partner-developer' },
  /** ENVISION/FORECASTING **/
  { name: 'Envision: User', value: 'envision::read', group: 'envision' },
  { name: 'Envision: View Manager', value: 'envision::write::view', group: 'envision' },
  /** RELAY **/
  { name: 'Relay: User', value: 'relay::read', group: 'relay' },
  { name: 'Relay: Enrollment Manager', value: 'relay::write::enrollment', group: 'relay' },
  { name: 'Relay: Incentive Manager', value: 'relay::write::incentive', group: 'relay' },
  { name: 'Relay: Marketing Manager', value: 'relay::write::marketing', group: 'relay' },
  { name: 'Relay: Customer Relationship Manager', value: 'relationship-manager', group: 'relay' },
  /** SHIFT/DERMS **/
  { name: 'Shift: Read', value: 'shift::read', group: 'shift' },
  { name: 'Shift: Asset Manager', value: 'shift::write::asset', group: 'shift' },
  { name: 'Shift: Event Manager', value: 'shift::write::event', group: 'shift' },
  { name: 'Shift: Enrollment Manager', value: 'shift::write::enrollment', group: 'shift' },
];

module.exports = Object.freeze({
  COMMODITIES,
  CURRENCIES,
  DAYS,
  DEVICE_CHARGE_STATUS,
  DEVICE_KINDS,
  DEVICE_MFGS,
  DEVICE_MFGS_OPTIONS,
  DEVICE_SUB_BRAND,
  EVENT_CATEGORY,
  EVENT_INITIATOR,
  EVENT_TYPE,
  LINKED_ACCOUNT_TYPES,
  LINKED_ACCOUNT_TYPES_PROVIDER_SETTINGS,
  MONTHS,
  PAYMENT_TYPES,
  ROLE_CONFIGURATIONS,
  ROLE_TYPES,
  STATE_NAMES,
  STATE_NAMES_AU,
  STATE_NAMES_CA,
  TIME_ZONES,
  VEHICLE_MAKES,
  INCENTIVE_PAYMENT_SERVICES,
  INCENTIVE_PAYMENT_TYPES,
});
